;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import type {
	DataProvider as DbDataProvider,
	DataProviderCredentials as DbDataProviderCredentials,
} from "@/prisma/generated/client";
import {
	queryFetcher,
	type RequestOptions,
} from "@/queries/config/query-fetcher";
import { userQueryKeys } from "@/queries/query-keys/user";

export interface DataProviderCredentials extends DbDataProviderCredentials {
	credentials: {
		accountChoices?: {
			accountKey: string;
			accountName: string;
		}[];
		accountKey?: string;
		accountName?: string;
		accountId?: string;
		databaseName?: string;
		isPending?: boolean;
		organizationChoices?: {
			organizationName: string;
			organizationUid: string;
		}[];
		organizationName?: string;
		organizationUid?: string;
		principal?: string;
		reconnectRequired?: boolean;
		scope?: string[];
		refreshTokenExpiresAt?: number;
		credentials?: {
			propertyGroupIds?: string[];
			projectIds?: string[];
			projectNames?: string[];
			workspaceGid?: string;
			workspaceName?: string;
		};
	}[];
}

export interface DataProviderWebhook {
	createdAt: string;
	id: string;
	isActive: boolean;
	lastFailureAt: string | null;
	lastSuccessAt: string | null;
	resourceId: string;
	resourceName: string | null;
	resourceType: string;
	status: string;
	updatedAt: string;
}

export interface DataProvider extends DbDataProvider, DataProviderCredentials {
	webhooks?: DataProviderWebhook[];
}

/**
 * Fetches data providers by workspace id
 * @param workspaceId - The ID of the workspace to fetch
 * @returns
 */
export async function getDataProviders(
	workspaceId: string,
	options?: RequestOptions,
): Promise<Omit<DataProvider, "apiKey" | "clientSecret">[]> {
	return queryFetcher(`/api/workspaces/${workspaceId}/data-provider`, {
		...options,
		method: "GET",
	});
}

export const getDataProvidersQueryOptions = (workspaceId: string) => {
	return queryOptions({
		enabled: !!workspaceId,
		placeholderData: keepPreviousData,
		queryFn: () => getDataProviders(workspaceId),
		queryKey: userQueryKeys.dataProviders(workspaceId),
		retry: 1,
	});
};
